"use client"

import { useEffect, useState } from "react"
import { ref, onValue } from "firebase/database"
import { db } from "../Firebase/firebase-config"
import "./partnerStyle.css"

export default function ProfileDialog({
  open,
  onOpenChange,
  profile,
  mainUserId,   // ← Receive it here
  title = "Partner Profile"
}) {
  const [mainUserInfo, setMainUserInfo] = useState({
    company_name: "Loading...",
    gstin: "Loading...",
    pan: "Loading..."
  })

  useEffect(() => {
    if (!open || !mainUserId) {
      setMainUserInfo({ company_name: "No access", gstin: "", pan: "" })
      return
    }

    const mainUserRef = ref(db, `profileDashboard/${mainUserId}`)
    const unsubscribe = onValue(mainUserRef, (snap) => {
      if (snap.exists()) {
        const data = snap.val()
        setMainUserInfo({
          company_name: data.company_name || "Main Business",
          gstin: data.gstin || "N/A",
          pan: data.pan || "N/A"
        })
      } else {
        setMainUserInfo({ company_name: "Account Not Found", gstin: "", pan: "" })
      }
    })

    return () => unsubscribe()
  }, [open, mainUserId])

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onOpenChange(false)
    }
    if (open) {
      document.body.style.overflow = "hidden"
      window.addEventListener("keydown", onKey)
    }
    return () => {
      document.body.style.overflow = "unset"
      window.removeEventListener("keydown", onKey)
    }
  }, [open, onOpenChange])

  const rows = [
    { label: "Name", value: profile?.name || "Partner" },
    { label: "Email", value: profile?.email || "N/A" },
    { label: "Role", value: "Partner (Viewer)" },
    { label: "Company", value: mainUserInfo.company_name },
    { label: "GSTIN", value: mainUserInfo.gstin },
    { label: "PAN", value: mainUserInfo.pan },
  ]

  if (!open) return null

  return (
    <div className="ps-dialog-backdrop" onClick={() => onOpenChange(false)}>
      <div className="ps-profile-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-glow"></div>

        <div className="ps-dialog-header">
          <div className="header-avatar">
            {profile?.name?.[0]?.toUpperCase() || "P"}
          </div>
          <h2 className="ps-modal-title">{title}</h2>
          <p className="ps-subtitle">
            You are a partner of <strong>{mainUserInfo.company_name}</strong>
          </p>
        </div>

        <div className="ps-dialog-body">
          <div className="profile-grid">
            {rows.map((row) => (
              <div key={row.label} className="profile-row">
                <span className="profile-label">{row.label}</span>
                <span className="profile-value">{row.value}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="ps-dialog-actions">
          <button className="ps-btn ps-btn-primary" onClick={() => onOpenChange(false)}>
            Close
          </button>
        </div>
      </div>
    </div>
  )
}